import { useEffect, useState } from 'react';
import { useTransitionStyles } from '@floating-ui/react';
/**
 * Manages delayed open/close transitions.
 *
 * @description
 * This hook adds a delay before updating the `isOpen` state to `false`.
 * This ensures that the transition animation completes
 * before the PopoverNext.Content is removed from the DOM.
 */
export const useDelayOpen = ({ open, transition = 0, showDelay = 0, hideDelay = 0, context, }) => {
    const [isOpen, setIsOpen] = useState(open);
    const getDuration = (transition = 0, type) => (typeof transition === 'number' ? transition : transition[type]);
    const { isMounted, styles } = useTransitionStyles(context, {
        common: {
            transitionProperty: 'opacity',
        },
        open: {
            opacity: 1,
            transitionDelay: `${showDelay}ms`,
            transitionDuration: `${getDuration(transition, 'enter')}ms`,
        },
        close: {
            opacity: 0,
            transitionDelay: `${hideDelay}ms`,
            transitionDuration: `${getDuration(transition, 'exit')}ms`,
        },
    });
    useEffect(() => {
        let timeout;
        if (!isMounted) {
            timeout = setTimeout(() => setIsOpen(false), hideDelay + getDuration(transition, 'exit'));
        }
        else {
            setIsOpen(true);
        }
        return () => timeout && clearTimeout(timeout);
    }, [isMounted, hideDelay, transition]);
    return { isOpen, styles };
};
//# sourceMappingURL=useDelayOpen.js.map